/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import axios from "axios";
import { pdfform } from "../pdflib/pdfform.js";
import { minipdf } from "../pdflib/minipdf.js";
import { PDFHelper } from "./PDF.helper";

import { mapValues } from "lodash";

/**
 *
 */
export class PDFFormHelper extends PDFHelper {
    private pdfData: any = null;
    private _isRead: boolean = false;
    private _label: string = "";
    private _fields: any = {};

    constructor(label?: string) {
        super();
        this._label = label;
    }

    public async read(pdfUrl: string) {
        const result = await axios.request({
            responseType: "arraybuffer",
            url: pdfUrl,
            method: "get",
            headers: {
                "Content-Type": "application/pdf",
            },
        });
        this._isRead = true;
        this.pdfData = result.data;
    }

    public setFields(fields: any) {
        this._fields = fields;
        return this;
    }

    public isRead() {
        return this._isRead;
    }

    public getLabel() {
        return this._label;
    }

    public show(fields: any = {}) {
        super.show(this.getBlobUrl(fields));
    }

    public print(fields: any = this._fields) {
        super.print(this.getBlobUrl(fields));
    }

    public download(fields: any = null, filename: string) {
        super.download(this.getBlobUrl(fields), filename);
    }

    public getBase64(fields: any) {
        return this.blobToBase64(this.getBlob(fields));
    }

    private getBlobUrl(fields: any) {
        return window.URL.createObjectURL(this.getBlob(fields));
    }

    private getBlob(fields: any) {
        return new Blob([this.fillFields(fields)], { type: "application/pdf" });
    }

    private fillFields(fields: any) {
        fields = mapValues(fields, (f) => [f]);
        return pdfform(minipdf()).transform(this.pdfData, fields);
    }
}



// WEBPACK FOOTER //
// ./src/helper/PDFForm.helper.ts